import { createAction } from 'redux-actions';

import {
  LOAD_ADDRESS_BOOK,
  LOAD_ADDRESS_BOOK_SUCCESS,
  LOAD_ADDRESS_BOOK_ERROR,
} from './type';

//Load list address book
export const loadAddressBookAction = createAction(LOAD_ADDRESS_BOOK);
export const loadAddressBookSuccessAction = createAction(
  LOAD_ADDRESS_BOOK_SUCCESS,
);
export const loadAddressBookErrorAction = createAction(LOAD_ADDRESS_BOOK_ERROR);
